import { observer } from "mobx-react-lite";
import React from "react";
import { useParams } from "react-router";
import { userStore } from "store/UserStore";
import Retool from ".";

const AuditMaterialSales = () => {
  const reportID = "7cb8148c-8a40-11ef-a2ef-2b84c960e6ff";
  const { id: BuildingId } = useParams();
  const { userProfile } = userStore;

  const embeddedData = {
    building_id: BuildingId,
    email: userProfile?.email,
    user_id: userProfile?.username,
    user_name: `${userProfile?.first_name} ${userProfile?.last_name}`,
  };

  return (
    <Retool
      url={reportID}
      embeddedData={embeddedData}
      className="h-[calc(100vh-120px)]"
    />
  );
};

export default observer(AuditMaterialSales);
